import { IStats } from "@mctypes/stats.types";
import { IWeeklyAppStarts } from "@schemas/statsSchema";
import { apiSlice } from "../../../apiSlice";
import { IStat } from "./WeeklyUserChart";

export const statsRTK = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWeeklyStats: builder.query<IStat[], IWeeklyAppStarts>({
      query: (input) => {
        return {
          url: `/stats/weekly`,
          method: "POST",
          body: {
            fromDate: input.fromDate,
            toDate: input.toDate,
            projectNo: input.projectNo,
            toggleUniqueUsers: input.toggleUniqueUsers,
            appName: input.appName,
            issueBoardTemplate: input.issueBoardTemplate,
          },
        };
      },
      providesTags: ["Stats"],
    }),
    getAllProjectsForStatsPage: builder.query<IStats.AllProjects[], string>({
      query: () => {
        return {
          url: `/stats/projects/all`,
          method: "POST",
        };
      },
      providesTags: ["Stats"],
    }),
  }),
});

export const { useGetWeeklyStatsQuery, useGetAllProjectsForStatsPageQuery } = statsRTK;
